
<div class="white">
    <div style="overflow: hidden;"
         v-resize="onResize"
         :class="background"
    >
        <div
            v-if="!loading"
            class="mb-1"
            style="height: 4px;"
        ></div>

        <v-progress-linear
            v-if   = "loading"
            color  = "primary"
            height = "5"
            class  = "w-100 mb-1"
            indeterminate
        />

        <v-expansion-panels accordion flat class="mb-1" v-model="expandFilter" v-if="showTitle" style="background-color: white">
            <v-expansion-panel class="pa-0" :key="1" style="background-color: white">
                <v-expansion-panel-header :ripple="false" expand-icon="" class="pa-0" style="background-color: white">
                    <c-column-header
                        :label = "label"
                        :class = "headerColor"
                        :title-border = "titleBorder"
                        style  = "font-size: 16px; max-width: calc(100% - 12px);
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;"
                    >
                        <template v-slot:pre>
                            <div v-if="titlePrefix">
                                <slot name="prefix" />
                            </div>
                            <a @click.stop="onClose" v-if="!zoom && leftArrow && !titlePrefix">
                                <v-icon size="20" class="pr-1 white--text">mdi-arrow-left-bold</v-icon>
                            </a>
                        </template>
                        <template v-slot:toolbar>
                            <slot name="toolbar"></slot>
                        </template>

                        <template v-slot:filter>
                            <div class="v-flex" style="margin-top: -2px">
                                <c-item-count :count="count" :key="count" v-if="showCount" />
                                <a @click.stop="onFilter"  v-if="showFilter">
                                    <v-icon size="18" class="pr-1 white--text">mdi-filter</v-icon>
                                </a>
                                <a @click.stop="onRemoveFilter"  v-if="showFilter && searchtext">
                                    <v-icon size="18" class="pr-1 white--text ">mdi-filter-off-outline</v-icon>
                                </a>
                                <!--
                                <a @click.stop="onZoom" v-if="zoom">
                                    <v-icon size="20" class="pr-1 white--text">mdi-arrow-expand-all</v-icon>
                                </a>
                                -->
                            </div>
                        </template>
                    </c-column-header>
                </v-expansion-panel-header>

                <v-expansion-panel-content eager class="pa-0 ma-0" style="padding-right: 10px!important;">
                    <div class="lm-border mt-1  mb-1 pa-3 pt-0 " :style="styleSearch" v-if="enableSearch">
                        <div class="pb-1">
                            <v-text-field
                                v-model        = "searchtext"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                append-icon    = "fas fa-search"
                                ref            = "searchfield"
                                @input         = "onSearch"
                                :clearable     = "true"
                                hide-details
                            />
                        </div>

                        <slot name="filter"  />
                    </div>
                    <div v-if="!enableSearch" class="mt-1 mb-1">
                        <slot name="filter"  />
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <v-fade-transition>
            <div :style="'max-height:' + scrollHeight + 'px; height:' + scrollHeight + 'px;'" :class="background">
                <virtual-scroller
                    v-if          = "items && scrollerType !== 'vuetify'"
                    ref            = 'scroller'
                    :items         = "filteredItems"
                    :min-item-size = "itemHeight ? itemHeight + itemGap : null"
                    :item-size     = "itemHeight ? itemHeight + itemGap : null"
                    :key-field     = "keyField"
                    :prerender     = "0"
                    :style         = "'max-height:' + scrollHeight + 'px'"
                    style          = "width: calc(100% - 2px)"
                >
                    <div slot-scope="{ item, index }" class="">
                        <slot name="card" v-bind:item="{ data: item, index: index }" />
                    </div>
                </virtual-scroller>

                <v-virtual-scroll
                    v-if         = "items && scrollerType === 'vuetify'"
                    :items       = "filteredItems"
                    :height      = "scrollHeight"
                    :item-height = "itemHeight + itemGap"
                    bench="1"
                    :key="xxx"
                >
                    <template v-slot:default="{ item }">
                        <div style="padding-right: 4px">
                            <slot name="card" v-bind:item="item" />
                        </div>
                    </template>
                </v-virtual-scroll>
            </div>
        </v-fade-transition>
    </div>
</div>
